import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/pack.webp'


const _withScopeId = n => (_pushScopeId("data-v-f93d985e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "example-packs" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "example-packs__image",
  src: _imports_0,
  alt: "The sample pack"
}, null, -1))
const _hoisted_3 = { class: "example-packs__footer" }
const _hoisted_4 = { class: "example-packs__name" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, " 1x Full Colour Large Mailer Box with Inside Print - Full Colour "),
  /*#__PURE__*/_createElementVNode("li", null, "1x Coloured Shredded Paper"),
  /*#__PURE__*/_createElementVNode("li", null, "1x Personalised Hand Written Card"),
  /*#__PURE__*/_createElementVNode("li", null, "1x Custom Sock Club Knit Socks"),
  /*#__PURE__*/_createElementVNode("li", null, "1x Moleskine Classic Hard Cover Notebook"),
  /*#__PURE__*/_createElementVNode("li", null, "1x YETI® - Rambler 10 oz Lowball - Navy")
], -1))
const _hoisted_6 = { class: "example-packs__dimensions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_popover = _resolveComponent("a-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('examplePacks_pack_name')), 1),
      _createVNode(_component_a_popover, { trigger: "hover" }, {
        content: _withCtx(() => [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", null, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.$t('examplePacks_pack_value_text')), 1),
              _createTextVNode(" €90.00 ")
            ]),
            _createElementVNode("span", null, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.$t('examplePacks_pack_weight_text')), 1),
              _createTextVNode(" 0.95kg ")
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("a", null, _toDisplayString(_ctx.$t('examplePacks_pack_more_info')), 1)
        ]),
        _: 1
      })
    ])
  ]))
}